export default {"src":"/_next/static/media/0x798D1bE841a82a273720CE31c822C61a67a601C3.ce583e10.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};